document.addEventListener('DOMContentLoaded', function () {
    class CustomPopupBox extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('click', (e) => {
                this.closePopup(e, () => { });
            });
        }

        openPopup($popupTemplate, fn) {
            // popupTemplate：需要替换的元素
            this.querySelector('.custom-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
            const media = this.querySelector('.custom-popup-box-content-inner video');
            if (media) {
                media.muted = false;
                media.autoplay = true;
                media.playsInline = true;
                media.addEventListener('loadedmetadata', () => {
                    if (media.videoWidth && media.videoHeight) media.style.aspectRatio = media.videoWidth + ' / ' + media.videoHeight;
                }, { once: true });
                media.play().catch(() => {});
            }
            document.querySelector('body').style.overflow = 'hidden';
            this.style.display = 'flex';
            fn();
        }
        closePopup(e, fn) {
            if (e.target.className == 'custom-popup-box-close' || e.target.className == 'custom-popup-box') {
                this.style.display = 'none';
                this.querySelector('.custom-popup-box-content-inner').innerHTML = '';
                document.querySelector('body').style.overflow = 'auto';
                fn();
            }
        }
    }
    if (!window.customElements.get('custom-popup-box')) {
        window.customElements.define('custom-popup-box', CustomPopupBox);
    }

    class CustomOpenPopup extends HTMLElement {
        constructor() {
            super();
            this.init();
            this.$popupBox = document.querySelector('custom-popup-box.custom-popup-box');
        }
        init() {
            // 这里放置初始化逻辑
            this.addEventListener('click', this.itemClick.bind(this));
        }
        itemClick() {
            // 这里放置自定义逻辑
            let $popupTemplate = this.querySelector('template') || this.querySelector('.custom-popup-template');

            $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

        }
    }
    if (!window.customElements.get('custom-open-popup')) {
        window.customElements.define('custom-open-popup', CustomOpenPopup);
    }

    class CustomSwiper extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.getAllAttributes()
            this.initSwiper()
        }

        get getCurrentSlidesPerView() {
            if (!this['breakpoints']) return 1;

            const screenWidth = window.innerWidth;

            // 将breakpoints按数值从小到大排序
            const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

            let current = sortedKeys[0]; // 默认取最小的

            // 遍历找到小于等于当前屏幕宽度的最大key
            for (let i = 0; i < sortedKeys.length; i++) {
                if (screenWidth >= sortedKeys[i]) {
                    current = sortedKeys[i];
                } else {
                    break;
                }
            }

            return this['breakpoints'][current].slidesPerView;
        }

        getAllAttributes() {
            let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar', 'centered-slides'];
            let jsonAttrs = ['breakpoints']
            for (const attr of this.attributes) {
                if (attr.name.startsWith('data-')) {
                    const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

                    let value = attr.value;
                    if (booleanAttrs.includes(cleanName)) {
                        value = value === 'true';
                    } else if (jsonAttrs.includes(cleanName)) {
                        value = this.parseSwiperBreakpoints(value);
                    }

                    this[cleanName] = value;
                }
            }
        }

        parseSwiperBreakpoints(str) {
            const result = {};
            const pairs = str.split(',');

            for (const pair of pairs) {
                const [breakpoint, values] = pair.split(':');
                if (!breakpoint || !values) continue;

                const [slides, space] = values.split('-').map(Number);

                result[breakpoint.trim()] = {
                    slidesPerView: slides,
                    spaceBetween: space
                };
            }

            return result;
        }

        initSwiper() {
            new Swiper(this, {
                // 这里放置 swiper 的配置
                effect: this['effect'],
                loop: this['loop'],
                centeredSlides: this['centered-slides'],
                autoplay: this['autoplay'] ? {
                    delay: this['autoplay'],
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                } : false,
                pagination: this['pagination'] ? {
                    el: '.swiper-pagination',
                    clickable: true,
                } : false,
                navigation: this['navigation'] ? {
                    nextEl: this['navigation-class'] ? `.${this['navigation-class']}-next` : '.swiper-button-next',
                    prevEl: this['navigation-class'] ? `.${this['navigation-class']}-prev` : '.swiper-button-prev',
                } : false,
                scrollbar: this['scrollbar'] ? {
                    el: ".swiper-scrollbar",
                    hide: true,
                } : false,
                breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
                on: {
                    init: e => {
                        if (e.passedParams.loop) {
                            let num = this.getCurrentSlidesPerView;
                            let sliderLength = e.slides.length;

                            if (this['centered-slides']) {
                                num += 2;
                            }

                            if (sliderLength <= num) {
                                for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                                    e.slides.forEach((slide) => {
                                        const clonedElement = slide.cloneNode(true);
                                        e.slidesEl.appendChild(clonedElement);
                                    })
                                }

                                setTimeout(() => {
                                    let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                                    $bullets.forEach((bullet, index) => {
                                        if (index >= sliderLength) {
                                            bullet.style.display = 'none';
                                        }
                                    })
                                }, 250)
                            }
                        }
                    }
                }
            })
        }

    }
    if (!window.customElements.get('custom-swiper')) {
        window.customElements.define('custom-swiper', CustomSwiper);
    }

    class CustomProductFaqs extends HTMLElement {
      constructor() {
        super();

        this.ProductTitle = this.querySelectorAll('.product-title');
        this.ProductFaqs = this.querySelectorAll('.product-faqs');
        this.ProductFaqsItems = this.querySelectorAll('.product-faq-item .faq-title');
        this.SearchInput = this.querySelector('.search-input');
        this.SearchChange = this.SearchChange.bind(this);
        this.ProductTitleClick = this.ProductTitleClick.bind(this);
        this.ProductFaqsItemsClick = this.ProductFaqsItemsClick.bind(this);

      }

        connectedCallback() {
            this.ProductTitle.forEach((title, index) => {
                title.addEventListener('click', () => {
                    this.ProductTitleClick(index);
                }); 
            })

            this.ProductFaqsItems.forEach((item) => {
                item.addEventListener('click', () => this.ProductFaqsItemsClick(item));
            })

            this.SearchInput.addEventListener('input', this.SearchChange);
        }

        ProductTitleClick(i) {
          if(i == null || this.ProductTitle[i].classList.contains('active')){
            return
          } else {
            this.ProductTitle.forEach((title, i) => {
              title.classList.remove('active');
              this.ProductFaqs[i].classList.remove('active');
            })

            this.ProductTitle[i].classList.add('active');
            this.ProductFaqs[i].classList.add('active');
            this.labelClick(i)
          }
        }

        ProductFaqsItemsClick(item) {
            item.classList.toggle('active');
        }

        SearchChange() {
            const value = this.SearchInput.value

            if(value == '') {
                this.ProductTitle.forEach((title, i) => {
                    title.style.display = 'flex';
                })
            } 
            if(value != '') {
                this.ProductTitle.forEach((title, i) => {
                    let titleText = title.getAttribute('data-product-title');
                    if(titleText.toLowerCase().includes(value.toLowerCase())) {
                        title.style.display = 'flex';
                    } else {
                        title.style.display = 'none';
                    }
                })
            }
        }

    labelClick(index) {
        // 添加新的活动状态
        const parent = this.ProductTitle[index].parentElement;
        if (parent && this.isScrollable(parent)) {
          const containerRect = parent.getBoundingClientRect();
          const targetRect = this.ProductTitle[index].getBoundingClientRect();
          const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 100;

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      isScrollable(el) {
        if (!el) return false;

        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;

        const canScrollVertically =
          (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally =
          (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

        return canScrollVertically || canScrollHorizontally;
      }
    }
    if (!window.customElements.get('custom-product-faqs')) {
        window.customElements.define('custom-product-faqs', CustomProductFaqs);
    }

    class ObBuyItNow extends HTMLElement {
      constructor() {
        super()
        this.init()
      }
      init() {
        // 这里放置初始化逻辑
        let _this = this
        let $button = _this.querySelector('.ob-buy-it-now-button')
        if ($button) {
          $button.addEventListener('click', () => _this.buttonClick())
        }
      }
      buttonClick() {
        // 这里放置自定义逻辑
        let checkout = this.closest('.product-form__checkout');
        let buyBtn = checkout?.querySelector('more-payment-options-link .shopify-payment-button__more-options') || checkout?.querySelector('.shopify-payment-button .shopify-payment-button__more-options');
        buyBtn?.click();
      }
    }
    if (!window.customElements.get('ob-buy-it-now')) {
      window.customElements.define('ob-buy-it-now', ObBuyItNow)
    }

});


